<template>
  <div>
    <div class="overlay">&nbsp;</div>
    <a-card class="verify-phone-form-card">
      <ValidationObserver ref="observer">
        <a-form
          :label-width="80"
          slot-scope="{ validate }"
          @submit.prevent="validate().then(handleSubmit)"
        >
          <h1 class="title">{{ labels.title }}</h1>
          <h2 class="subtitle">
            {{
              !nai && bonus !== 0
                ? labels.subtitle_bonus.replace("{variable}", bonus)
                : labels.subtitle
            }}
          </h2>
          <!-- // TODO: Card styling -->
          <p class="description" v-html="description"></p>
          <Input
            v-if="sent"
            v-model="form.code"
            type="text"
            rules="required"
            vid="code"
            :placeholder="labels.form.code.placeholder"
            size="large"
            :allowClear="true"
            :label="labels.form.code.label"
          />
          <a-form-item style="text-align: right">
            <a-button
              type="default"
              html-type="submit"
              :loading="submitting"
              :disabled="submitting"
              size="large"
              class="btn-verify"
              @click.prevent="validate().then(handleSubmit)"
            >
              <span>{{ sent ? labels.form.submit : labels.form.send }}</span>
            </a-button>
          </a-form-item>
        </a-form>
      </ValidationObserver>
    </a-card>
  </div>
</template>
<script>
import { ValidationObserver } from "vee-validate";
import Input from "@/components/core/VeeValidateForm/Input";
import labels from "@/utils/labels";
import _ from "lodash";
import accounting from "accounting";
import { mapActions, mapGetters } from "vuex";
const initialState = {
  code: "",
};
export default {
  name: "VerifyPhoneForm",
  components: {
    ValidationObserver,
    Input,
  },
  props: {
    nai: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      form: _.cloneDeep(initialState),
      submitting: false,
      labels: labels.verifyPhoneForm,
      bonus: 0,
      sent: false,
    };
  },
  methods: {
    ...mapActions("clientAuth", [
      "refreshBalance",
      "handleVerifyPhone",
      "fetchCommissionProfile",
    ]),
    async handleSubmit() {
      try {
        await this.handleVerifyPhone(this.sent ? this.form : false);
        this.$message.success(
          this.sent ? this.labels.form.success : this.labels.form.sent_success
        );
        this.form = _.cloneDeep(initialState);
        this.$refs.observer?.reset();
        if (this.sent) {
          this.refreshBalance().finally(() => {
            this.syncing = false;
          });
          this.$nextTick(() => {
            this.$router.push({ name: "welcome" });
          });
        }
        this.sent = true;
      } catch (error) {
        this.$error({
          title: this.labels.form.error,
          content: this.sent
            ? this.labels.form.error_code
            : error?.response?.data?.message ||
              error?.response?.message ||
              error.message,
          centered: true,
        });
      } finally {
        this.submitting = false;
      }
    },
    async handleFetchCommissionProfile() {
      try {
        const { data } = await this.fetchCommissionProfile();
        const bonus = data?.schema?.find(
          (item) => item.type === "USER_REGISTRATION_BONUS_CLIENT"
        );
        if (bonus?.amount) {
          this.bonus = accounting.formatMoney(
            bonus.amount,
            "RD$ ",
            2,
            ",",
            "."
          );
        } else {
          this.bonus = 0;
        }
      } catch (error) {
        console.error("ERROR", error);
      }
    },
  },
  computed: {
    ...mapGetters("clientAuth", ["getLoggedUser"]),
    loggedUser() {
      return this.getLoggedUser;
    },
    description() {
      const label = this.labels[this.sent ? "after" : "before"];
      const user = this.loggedUser;
      const code = user?.whatsapp_country?.code
        ? user.whatsapp_country.code
        : "+1";
      const html =
        "<p>" +
        code +
        user.whatsapp.replace(/(\d{3})(\d{3})(\d{4})/, " ($1) ***-$3") +
        "</p>";
      return label.replace("{phone}", html);
    },
  },
  watch: {
    nai: {
      immediate: true,
      deep: true,
      handler(val, old) {
        if (val !== old && !val) {
          this.handleFetchCommissionProfile();
        }
      },
    },
  },
};
</script>
<style lang="scss">
@import "~@/assets/scss/variable";
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  background-color: rgba(0, 0, 0, 0.6);
}
.verify-phone-form-card {
  background-color: var(--card-bg);
  border-color: var(--card-shadow);
  padding: 3.125rem;
  border-radius: 8px;
  z-index: 4;
  @media screen and (max-width: $screen-mobile) {
    padding: 2.125rem 1rem;
  }
  .title {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 2rem;
    margin-bottom: 1rem;
    text-align: center;
  }
  .subtitle {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    font-weight: 400;
    margin: 0;
    line-height: 1.3;
    word-break: break-word;
    font-size: 1.2rem;
    margin-bottom: 1rem;
  }
  .description {
    font-family: "Exo 2", sans-serif;
    color: var(--text);
    margin: 0;
    word-break: break-word;
    margin-bottom: 1rem;
    text-align: center;
  }
  .ant-card-body {
    padding: 0;
  }
  .ant-form label {
    font-size: 0.875rem;
    color: var(--text);
    font-family: "Roboto", sans-serif;
  }
  .ant-input {
    background-color: var(--input-bg);
    height: 3.75rem;
    color: var(--text);
    &:active,
    &:focus,
    &:hover {
      border-color: var(--text-muted);
    }
  }
  .ant-input-affix-wrapper {
    .ant-input:not(:first-child) {
      padding-left: 2.8125rem;
    }
    .ant-input-prefix {
      color: var(--text);
      font-size: 1.375rem;
      font-family: "Roboto", sans-serif;
    }
  }

  .has-error .ant-input-affix-wrapper .ant-input,
  .has-error .ant-input-affix-wrapper .ant-input:hover {
    background-color: var(--danger);
  }

  .btn-verify {
    color: var(--btn-text-primary);
    background-color: var(--btn-bg-primary);
    border-color: var(--btn-bc-primary);
    height: 51px;
    padding: 0 1.75rem;
    @media screen and (max-width: 596px) {
      width: 100% !important;
    }
  }
}

input:-internal-autofill-selected {
  background-color: var(--input-bg) !important;
  border-color: var(--text-active) !important;
  color: var(--text-muted) !important;
}

// animation
@keyframes shadowGlow {
  0% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.15);
  }
  25% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.25);
  }
  50% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.35);
  }
  50% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.45);
  }
  100% {
    box-shadow: 0 0 15px rgba(55, 245, 249, 0.15);
  }
}
</style>
